import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/BlogPage.head';
import { BlogPage } from '@pages/BlogPage';

export const Route = createFileRoute('/blog/')({
  component: BlogPage,
  head: () => head,
});
